<template>
    <RawTag v-bind="$props" :class="[action, { 'action-tag': action }]" @click="onClick">
        <template #right-icon>
            <slot name="icon">
                <component :is="icon" :size="iconSize" />
            </slot>
        </template>
        <template #left-icon>
            <slot name="left-icon" />
        </template>
    </RawTag>
</template>

<script lang="ts">
    import { Component, Vue, Prop, Emit } from 'vue-property-decorator';
    import RawTag from './RawTag.vue';
    import '@eloomi/icons/menu/menu-action-icon';
    import '@eloomi/icons/actions/actions-close-bold';
    import '@eloomi/icons/actions/actions-add-bold';
    import '@eloomi/icons/products-pages/products-and-pages-course-builder-lock-bold';

    @Component({
        components: { RawTag },
    })
    export default class Tag extends Vue {
        @Prop({ type: String, required: true }) public title!: string;
        @Prop({ default: 'topic', type: String }) public variant?: 'topic' | 'category' | 'skill' | 'button';
        @Prop({ default: 'small', type: String }) public size?: 'small' | 'large' | 'medium';
        @Prop({ default: false, type: Boolean }) public isActive?: boolean;
        @Prop({ default: undefined, type: String }) public action?: 'delete' | 'add' | 'more' | 'lock';
        @Prop({ default: undefined, type: String }) public intention?: 'danger';

        @Emit('click')
        public onClick() {
            return;
        }

        public get icon() {
            switch (this.action) {
                case 'more':
                    return 'elm-menu-action-icon-icon';
                case 'delete':
                    return 'elm-actions-close-bold-icon';
                case 'add':
                    return 'elm-actions-add-bold-icon';
                case 'lock':
                    return 'elm-products-and-pages-course-builder-lock-bold-icon';
                default:
                    return undefined;
            }
        }

        public get iconSize() {
            if (this.size === 'large' && this.action === 'more') {
                return 20;
            }

            if (this.size === 'medium' && this.action === 'delete') {
                return 12;
            }

            if (this.action === 'add') {
                return 16;
            }

            if (this.action === 'lock') {
                return 12;
            }

            if (this.size === 'large' && this.action === 'delete') {
                return 10;
            }
            return 10;
        }
    }
</script>
<style lang="less" scoped>
    &.action-tag {
        user-select: none;
    }
</style>
